import {generateTrackingService} from 'app/helpers/trackingTrigger';

const loadIvw = (ivw, callback) => {
  //Source: https://cleverbeagle.com/blog/articles/tutorial-how-to-load-third-party-scripts-dynamically-in-javascript

  const dns = window.innerWidth < 768 ? ivw.ivw_dns_mobil : ivw.ivw_dns_desktop;
  if (!dns) {
    return;
  }

  const full_dns = 'https://' + dns + '.fupa.net';

  if (!document.getElementById('IOMmBundle')) {
    const preloadBundle = document.createElement('link');
    preloadBundle.rel = 'preload';
    preloadBundle.as = 'script';
    preloadBundle.href = full_dns + '/iomm/latest/manager/base/es6/bundle.js';
    preloadBundle.id = 'IOMmBundle';
    document.body.appendChild(preloadBundle);
  }

  if (!document.getElementById('preloadLoader')) {
    const preloadLoader = document.createElement('link');
    preloadLoader.rel = 'preload';
    preloadLoader.as = 'script';
    preloadLoader.href = full_dns + '/iomm/latest/bootstrap/loader.js';
    preloadLoader.id = 'preloadLoader';
    document.body.appendChild(preloadLoader);
  }

  const existingScript = document.getElementById('iommLoader');
  if (!existingScript) {
    const script = document.createElement('script');
    script.src = full_dns + '/iomm/latest/bootstrap/loader.js';
    script.id = 'iommLoader';
    document.body.appendChild(script);
    script.onload = () => {
      if (callback) {
        callback();
      }
    };
  }

  if (existingScript && callback) {
    callback();
  }
};

const pushIvwTracker = generateTrackingService();

const callIvw = (ivw, ignoreLegacyIvw) => {
  if (typeof window === 'undefined') {
    return;
  }

  if (!window.IOMm || !Object.keys(ivw).length) {
    return;
  }

  let st;
  let dn;
  let cp = ivwGetPageCategory();
  if (window.innerWidth < 768) {
    st = ivw.ivw_st_mobil;
    cp = 'mobil_' + cp;
    dn = ivw.ivw_dns_mobil;
  } else {
    st = ivw.ivw_st_desktop;
    dn = ivw.ivw_dns_desktop;
  }

  if (st === '' || dn === '') {
    return;
  }

  dn += '.fupa.net';
  const configObj = ignoreLegacyIvw ? {mh: 5} : {};
  IOMm('configure', {st, dn, ...configObj});

  if (ivw.ivw_cp_prefix) {
    cp = ivw.ivw_cp_prefix + cp;
  }

  pushIvwTracker({cp}, window.location.href, event => window.IOMm('pageview', event));
};

const ivwGetPageCategory = () => {
  let cp = 'fp_rc_sp';

  if (window.location.pathname.startsWith('/about')) {
    cp = 'fp_rc_uk';
  }
  if (window.location.pathname.startsWith('/region')) {
    cp = 'home_fp_rc_sp';
  }

  return cp;
};

export {loadIvw, callIvw};
